import { render, staticRenderFns } from "./ProductScaleChart.vue?vue&type=template&id=59c5d957&"
import script from "./ProductScaleChart.ts?vue&type=script&lang=ts&"
export * from "./ProductScaleChart.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports